export default __webpack_public_path__ + "static/spitz-4adde5e496bce45b91a685630d26d64a.mp4";